import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles2 from '../EcsPortal.module.scss';
import { handleImpressionsTrack, modifyEcs, sendOtp, updateEcs, verifyOtp } from '../../../api';
import ResendOtp from '../../common/ResendOtp';
import { useAuth } from '../../../contexts/auth';
import { clickTracker } from '../../../lib/common';

export default function OtpComponents({
  data,
  setData,
  setCurrentComponent,
  currentComponent,
  status,
  setResultMessage,
  campaigndetails,
  setIsHelful,
  getAllEcsDetails,
  setIsUpdate,
  projectId,
  faqObj,
}) {
  const [authState] = useAuth();
  const { selectedBusiness, userDetails } = authState;
  const [otpValues, setotpvalues] = useState({ 1: '', 2: '', 3: '', 4: '', 5: '', 6: '' });
  const [disable, setDisable] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoadingText, setIsLoadingText] = useState('');

  const queryParams = new URLSearchParams(window.location.search);
  const handleMobile = (mobile) => {
    if (mobile) return `xxxxxxx${mobile.substring(mobile.length - 4, mobile.length)}`;
    return '';
  };
  useEffect(() => {
    if (otpValues[1] && otpValues[2] && otpValues[3] && otpValues[4] && otpValues[5] && otpValues[6]) {
      setDisable(false);
      setData({
        ...data,
        otp: `${otpValues[1] + otpValues[2] + otpValues[3] + otpValues[4] + otpValues[5] + otpValues[6]}`,
      });
    }
  }, [otpValues]);

  const getOtpSubmit = async () => {
    const res = await verifyOtp(data.otp);
    setDisable(true);
    setIsLoadingText('Loading...');
    if (res.errorCode) {
      setIsLoadingText('');
      setDisable(true);
      setErrorMessage(res.message);
    } else {
      setErrorMessage('');
    }

    const campnsIds = [];
    let amountsum = 0;
    if (campaigndetails)
      campaigndetails.map((item) => {
        if (data.campaigns[item.camp_id]) amountsum += item.camp_monthly_budget;
        return '';
      });
    if (status.toLowerCase() === 'cancel') {
      campaigndetails.map((item) => {
        campnsIds.push(item.camp_id);
        return '';
      });
    } else {
      Object.keys(data.campaigns).map((item) => {
        if (data.campaigns[item]) {
          campnsIds.push(item);
        }
        return '';
      });
    }

    if (res.errorCode === 0) {
      let _res = '';
      if (status.toLowerCase() !== 'cancel') {
        const req = {
          pid: queryParams.get('pid') || selectedBusiness.parentid,
          city: queryParams.get('city') || selectedBusiness.data_city,
          reason: status.toLowerCase() === 'cancel' ? 'Canceling all the campaigns' : data.reasons, // reason will be null for canceled
          url: window.location.href, //  window location url
          compname: '', // selected buisness
          campaignId: campnsIds.join(), // for canceled case all campaigns will be selected
          amount: amountsum, //  total selected campaigns total
          action: status.toLowerCase() === 'stop' || status.toLowerCase() === 'cancel' ? 'deactivate' : 'activate', // for pause activate and for reactivate/canceled  deactivate
        };
        _res = await updateEcs({ ...req });
        if (setIsUpdate) setIsUpdate(true);
      } else {
        const req = {
          pid: queryParams.get('pid') || selectedBusiness.parentid,
          city: queryParams.get('city') || selectedBusiness.data_city,
          mtype: 5,
        };
        _res = await modifyEcs({ ...req });
      }
      await getAllEcsDetails();
      setIsLoadingText('');
      if (_res) {
        setIsHelful(true);
        if (status.toLowerCase() !== 'reactivate') setResultMessage(_res.result);
        setCurrentComponent(currentComponent + 1);
      }
    }
  };
  return (
    <div>
      <>
        <div className="font12 fw700 color111 mt-2">
          Please enter the code sent on {handleMobile(userDetails?.mobile)}
        </div>

        <div className={`${styles2.Otpfield__Box}`} style={{ display: 'flex' }}>
          {Object.keys(otpValues).map((item) => {
            return (
              <input
                id={item}
                type="tel"
                autoComplete="off"
                tabIndex={item}
                name={`o${item}`}
                maxLength={1}
                className={`${styles2.Otpfield}`}
                value={otpValues[item]}
                onKeyDown={(e) => {
                  const pattern = /^[0-9]+$/;
                  const ans = !['Backspace'].includes(e.key) ? pattern.test(e.key) : true;
                  setErrorMessage('');
                  if (!ans) {
                    e.preventDefault();
                  } else if (e.key === 'Backspace' && !e.target.value) {
                    const prev = e.target.previousElementSibling;
                    if (prev) prev.focus();
                    setDisable(true);
                  } else if (e.key.length === 1 && e.target.value) {
                    setErrorMessage('');
                    const next = e.target.nextElementSibling;
                    if (next) {
                      next.focus();
                    }
                  }
                }}
                onChange={(e) => {
                  setErrorMessage('');
                  const val = e.target.value;
                  setotpvalues({ ...otpValues, [item]: val });
                  if (val !== '') {
                    const next = e.target.nextElementSibling;
                    if (next) {
                      next.focus();
                    }
                  } else {
                    const prev = e.target.previousElementSibling;
                    if (prev) prev.focus();
                    setDisable(true);
                  }
                }}
                placeholder=""
              />
            );
          })}
        </div>
        <ResendOtp callSendOTP={sendOtp} />
        {errorMessage && (
          <span
            className="colorEC4 font14 fw500 ml-5"
            style={{
              display: 'flex',
              textAlign: 'center',
              justifyContent: 'center',
              textTransform: 'capitalize',
              marginTop: '10px',
            }}
          >
            {errorMessage}
          </span>
        )}
        <div className={`${styles2.Accordion__Contant__Btnbox}`}>
          <button
            type="button"
            className={`${styles2.Accordion__Contant__Button} blue_whitefill_animate font14 fw600 color007 mt-20`}
            style={{
              backgroundColor: '#0076d7',
              border: `1px solid #E0E0E0`,
              transitionProperty: 'background-color, background-image, border-color',
              transition: 'all 0.8s',
              color: `#fff`,
            }}
            onClick={async () => {
              await clickTracker(`FAQ_${status.toLowerCase()}_back`, `ecs_FAQ_${status.toLowerCase()}`);
              if (projectId === 'csportal') {
                const liVal = 'click';
                const liTrd = `cta_back`;
                const faqTypeVal = '';
                const othersData = [];
                const llTrd = `issue_ecs`;
                const llTrdInside = `faq_${faqObj?.faqKey}`;
                await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState, llTrdInside);
              }
              setCurrentComponent(currentComponent - 1);
            }}
          >
            Back
          </button>
          <button
            type="button"
            className={`${styles2.Accordion__Contant__Button} bluefill_animate font14 fw600 colorFFF mt-20`}
            style={{
              backgroundColor: `${!disable ? '#0076d7' : '#CCCCCC'}`,
              border: `1px solid ${disable ? '#E0E0E0' : '#CCCCCC'}`,
              transitionProperty: 'background-color, background-image, border-color, box-shadow',
              transition: 'all 0.8s',
              color: `#FFFFFF`,
            }}
            disabled={disable}
            onClick={async () => {
              await clickTracker(`FAQ_${status.toLowerCase()}_continue`, `ecs_FAQ_${status.toLowerCase()}`);
              if (projectId === 'csportal') {
                const liVal = 'click';
                const liTrd = `cta_continue`;
                const faqTypeVal = '';
                const othersData = [];
                const llTrd = `issue_ecs`;
                const llTrdInside = `faq_${faqObj?.faqKey}`;
                await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState, llTrdInside);
              }
              getOtpSubmit();
            }}
          >
            {isLoadingText || 'Continue'}
          </button>
        </div>
      </>
    </div>
  );
}

OtpComponents.propTypes = {
  data: PropTypes.object,
  setData: PropTypes.func,
  setCurrentComponent: PropTypes.func,
  currentComponent: PropTypes.number,
  status: PropTypes.string,
  setResultMessage: PropTypes.func,
  campaigndetails: PropTypes.array,
  setIsHelful: PropTypes.func,
  getAllEcsDetails: PropTypes.func,
  setIsUpdate: PropTypes.func,
  projectId: PropTypes.string,
  faqObj: PropTypes.object,
};
